import { createSvgIconComponent } from "../utils";

export const IconOnePassBg = createSvgIconComponent({
  path: "M18.149-32.882C3.56-13.461-1.764 10.072 1.408 32.37l17.144 122.778 37.409-49.799 61.977 46.557c38.557 28.963 93.596 21.027 122.68-17.691 29.084-38.717 21.376-93.789-17.182-122.752l-82.598-62.047C102.272-79.536 47.233-71.6 18.149-32.882Zm178.827 79.57c19.228 14.443 23.069 41.89 8.566 61.197-14.504 19.307-41.934 23.262-61.161 8.819L82.404 70.148 55.952 105.36 44.839 25.823c-1.527-11.06 1.139-22.726 8.378-32.363 14.503-19.308 41.933-23.263 61.161-8.82l82.598 62.047Z",
  fill: "currentColor",
  viewBox: "0 0 205 170",
});
